import { createContext, useContext } from 'react';
import type { ReactNode } from 'react';
import { auth, db, storage } from '../firebase/config';
import type { Auth, User } from 'firebase/auth';
import type { Firestore } from 'firebase/firestore';
import type { FirebaseStorage } from 'firebase/storage';

// Define the shape of our Firebase context
type FirebaseContextType = {
  auth: Auth;
  db: Firestore;
  storage: FirebaseStorage;
  currentUser: User | null;
};

// Create the context with default values
const FirebaseContext = createContext<FirebaseContextType>({
  auth: auth,
  db: db,
  storage: storage,
  currentUser: null,
});

// Create a provider component
export const FirebaseProvider = ({ children }: { children: ReactNode }) => {
  // We'll implement the current user state management here
  const currentUser = auth.currentUser;

  const value = {
    auth,
    db,
    storage,
    currentUser,
  };

  return (
    <FirebaseContext.Provider value={value}>
      {children}
    </FirebaseContext.Provider>
  );
};

// Custom hook to use the Firebase context
export const useFirebase = () => {
  return useContext(FirebaseContext);
};

export default FirebaseContext;
